import { FC, SVGProps } from "react";

export const PeopleIcon: FC<SVGProps<SVGSVGElement>> = ({
  className,
  width = 20,
  height = 20,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <circle cx="9" cy="8" r="4" />
    <path d="M2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v1" />
    <path d="M16 4.2a4 4 0 0 1 0 7.6" />
    <path d="M18.5 14.4A6 6 0 0 1 22 20v1" />
  </svg>
);
